module.exports = __webpack_public_path__ + "img/profile-bird.78085641.svg";